"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var GanttChartProjectLink = function (_a) {
    var style = _a.style, project = _a.project, onSetEdit = _a.onSetEdit, onMouseOver = _a.onMouseOver, onMouseLeave = _a.onMouseLeave, historic = _a.historic;
    return (react_1.default.createElement("button", { className: 'gantt-chart-project-link flex flex-row', type: 'button', style: style, "data-historic": historic, onClick: function (e) {
            !historic && onSetEdit({ x: e.clientX, y: e.clientY });
        }, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave },
        react_1.default.createElement("div", { className: 'img' }, project.client &&
            project.client.clientImage ?
            react_1.default.createElement("img", { src: project.client.clientImage.filename, alt: project.client.clientName }) :
            react_1.default.createElement("span", null, project.client && project.client.clientName.substr(0, 1))),
        react_1.default.createElement("span", null,
            project.client && project.client.clientName + ': ',
            project.projectName,
            (project.startDate && !project.endDate) && " - Start Date: " + dayjs_1.default(project.startDate).format('DD/MM/YYYY'),
            project.endDate && " - Deadline: " + dayjs_1.default(project.endDate).format('DD/MM/YYYY'),
            !project.active && ' (Historic)')));
};
exports.default = GanttChartProjectLink;
